import { JackpotConfigRequest } from "@pages/Admin/creditsManagement/types";
import axiosClient from "apis/axios-client";
import axios, { AxiosError, AxiosResponse } from "axios";


interface GetCreditConfigurationParams {
  SearchWithName?: string;
  PageNumber?: number;
  PageSize?: number;
}

interface CreditConfigAPI {
  creditManagementId: number;
  configurationName: string;
  createdDate: string;
  status: 'Active' | 'Disabled';
  answer: number;
  request: number;
  invite: number;
  signup: number;
  initialFive: number;
}

interface CreditConfigResponse {
  totalRecords: number;
  data: CreditConfigAPI[];
}


export const getCreditConfiguration = async (
  params: GetCreditConfigurationParams = {}
): Promise<CreditConfigResponse> => {
  try {
    const response = await axiosClient.get<CreditConfigResponse>(
      '/admin/AdminCredit/GetCreditConfiguration',
      {
        params: {
          SearchWithName: params.SearchWithName,
          PageNumber: params.PageNumber,
          PageSize: params.PageSize,
        },
      }
    )as unknown as CreditConfigResponse;
    return response;
  } catch (error) {
    console.error('Error fetching credit configuration:', error);
    throw error;
  }
};





// Interface for query parameters
interface DeleteCreditConfigurationParams {
  id: number;
}

// Function to delete a credit configuration by ID
export const deleteCreditConfiguration = async (
  params: DeleteCreditConfigurationParams
): Promise<void> => {
  try {
    const response: AxiosResponse<void> = await axiosClient.delete(
      '/admin/AdminCredit/DeleteCreditConfiguration',
      {
        params: {
          id: params.id,
        },
      }
    );
    console.log('Delete Credit Configuration Response:', response); // Logs the response (if any)
    return ; 
  } catch (error) {
    console.error('Error deleting credit configuration:', error);
    throw error;
  }
};


// Interface for path parameters


// Add Credit Configuration Request
interface AddCreditConfigurationRequest {
  configName: string;
  answer: number;
  request: number;
  signup: number;
  initialFive: number;
  description: string;
  referrals: number;
  isActive: boolean;
}

interface AddCreditConfigurationResponse {
  id: string; // Example field, adjust as per your API
  message: string;
}

// API function to add a credit configuration
export const addCreditConfiguration = async (
  data: AddCreditConfigurationRequest
): Promise<AxiosResponse<AddCreditConfigurationResponse>> => {
  try {
    const response = await axiosClient.post<AddCreditConfigurationResponse>(
      '/admin/AdminCredit/AddCreditConfiguration',
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response;
  } catch (error) {
    
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Failed to add credit configuration');
    }
    throw new Error('An unexpected error occurred');
  }
};





// Interface for the Update credit configuration data
interface CreditConfigData {
  configurationName: string;
  answer: number;
  request: number;
  invite: number;
  signup: number;
  initialFive: number;
  isActive: boolean;
  isPromotion: boolean;
  validFrom: string; // ISO date string
  validTo: string;   // ISO date string
  description: string;
}

// Interface for potential error response
interface ApiErrorResponse {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  [key: string]: string | number | undefined; // For additional properties
}


export const updateCreditConfiguration = async (
  creditManagementId: number,
  configData: CreditConfigData
): Promise<unknown> => {
  try {
    const response = await axiosClient.post(
      `/admin/AdminCredit/UpdateCreditConfiguration?CreditManagementId=${creditManagementId}`,
      {
        configurationName: configData.configurationName,
        answer: configData.answer,
        request: configData.request,
        invite: configData.invite,
        signup: configData.signup,
        initialFive: configData.initialFive,
        isActive: configData.isActive,
        isPromotion: configData.isPromotion,
        validFrom: configData.validFrom,
        validTo: configData.validTo,
        description: configData.description
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    return response; // response.data is already handled by interceptor
  } catch (error) {
   
    const axiosError = error as AxiosError<ApiErrorResponse | string>;
    
    if (axiosError.response) {
      throw axiosError.response; // Could be string or ApiErrorResponse
    }

    throw axiosError.message || 'Failed to update credit configuration';
  }
};



